import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Registry } from 'react-registry';
import { Route, Switch } from 'react-router';

import { ConditionTypeRegistry } from 'common/form/fields/condition/ConditionTypeRegistry';
import { IPanelProps } from 'core/decorators/Panel';
import PanelUtil from 'core/util/PanelUtil';
import TokenSession from "core/util/session/TokenSession";
import { nDef } from "core/util/TypeUtils";
import UrlUtil from 'core/util/UrlUtil';
import PageConfig from "panels/page/PageConfig";
import NonIdealState from 'common/fragments/NonIdealState';

/**
 * @overview: Splits container children up into pages then groups them together
 * into a react-router {@link Switch}.
 *
 * @author: jesposito
 */

export interface IFilterResult {
	pIndexes: number[];
	pages: Array<IPanelProps<any>>;
	others: Array<IPanelProps<any>>;
}

const ConnectedSwitch = connect((state: any) => ({
	location: state.router.location
}))(Switch as any);

interface IPathContextProps {
	paths: string[];
}

const PathContext = React.createContext<IPathContextProps>({paths: []});

function ManualRedirect({ uri }: { uri: string; }) {
	useEffect(() => {
		if (uri) {
			window.location.href = uri;
		}
	}, [uri]);
	return null;
}

export default class PageUtil {
	public static PAGE_ID = "page";

	public static groupPages(pages: Array<IPanelProps<any>>, editing?: boolean): JSX.Element {

		/* const pageElements = pages.map((p) => {
			const { instance, config } = p;

			return (
				<Route exact={UrlUtil.isAppPath(config.path)} path={UrlUtil.getLink(config.path)}>
					{Registry.createElement({id: PageUtil.PAGE_ID, registry: "panels"}, {instance})}
				</Route>
			);
		}); */

		return (
			<PathContext.Consumer key="routes">
				{(context) => (
					<ConnectedSwitch>
						{pages.map((p) => {
							const { instance, config } = p;
							const path = UrlUtil.getLink(...context.paths, config.path);
							const exact = UrlUtil.isAppPath(path) || !config.path;

							if (config.redirect) {
								return (
									<Route key={instance} exact={exact} path={path}>
										{
											editing ? (
												<NonIdealState title="Redirect" description={"From: " + path + "; To: " + config.redirect} />
											) : (
												<ManualRedirect uri={config.redirect} />
											)
										}
									</Route>
								);
							}

							return (
								<Route key={instance} exact={exact} path={path}>
									<PathContext.Provider key={instance} value={{paths: [...context.paths, config.path]}}>
										{Registry.createElement({id: PageUtil.PAGE_ID, registry: "panels"}, {instance})}
									</PathContext.Provider>
								</Route>
							);
						})}
					</ConnectedSwitch>
				)}
			</PathContext.Consumer>
		);
	}

	public static filterPages(children: Array<IPanelProps<any>>): IFilterResult {
		const pages: Array<IPanelProps<any>> = [];
		const pIndexes: number[] = [];

		const others = children.filter((p, i) => {
			if(p && p.id === PageUtil.PAGE_ID) {

				pIndexes.push(i);
				pages.push(p);

				return false;
			}
			return true;
		});

		return {others, pages, pIndexes};
	}
}



// WEBPACK FOOTER //
// ./src/core/components/layout/PageUtil.tsx